import { FormHelperText } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { Field, useFormikContext } from 'formik';
import moment from 'moment';
import * as React from 'react';
import { useObservable } from 'react-use-observable';
import ExportWarning from 'v2/components/Shared/ExportWarning';
import { CheckboxFormField } from 'v2/components/Shared/FormFields/CheckboxFormField';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import TextFormField from 'v2/components/Shared/FormFields/TextFormField';
import eduzzAccountsService from 'v2/services/eduzzAccount';
import { financialStatementService } from 'v2/services/financialStatement/statement';

import styles from './styles';

import type { ExportStatement } from '../constants';
import type { Moment } from 'moment';

const today = moment();
const datePreset = [
  {
    id: 'week',
    text: '7 dias',
    start: moment().subtract(7, 'days'),
    end: today,
  },
  {
    id: 'halfMonth',
    text: '15 dias',
    start: moment().subtract(15, 'days'),
    end: today,
  },
  {
    id: 'month',
    text: '30 dias',
    start: moment().subtract(30, 'days'),
    end: today,
  },
  {
    id: 'twoMonth',
    text: '60 dias',
    start: moment().subtract(60, 'days'),
    end: today,
  },
  {
    id: 'threeMonth',
    text: '90 dias',
    start: moment().subtract(90, 'days'),
    end: today,
  },
  {
    id: 'fourMonth',
    text: '120 dias',
    start: moment().subtract(120, 'days'),
    end: today,
  },
  {
    id: 'sixMonth',
    text: '180 dias',
    start: moment().subtract(180, 'days'),
    end: today,
  },
];

function Form() {
  const classes = styles();
  const { values, setFieldValue, errors } = useFormikContext<ExportStatement>();
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [filters] = useObservable(() => financialStatementService.getFilters(), []);

  const firstSelectedDate = values.date[0];
  const isOutsideRange = (day: Moment) =>
    day.isAfter(moment()) || day.isAfter(moment(firstSelectedDate, 'DD/MM/YYYY').add(12, 'months').add(1, 'days'));

  React.useEffect(() => {
    if (filters?.periodPreset) setFieldValue('date', [moment().subtract(filters?.periodPreset, 'days'), today]);
  }, [filters?.periodPreset, setFieldValue]);

  return (
    <>
      <ExportWarning />

      <div className={classes.checkList}>
        <div className={classes.optionWithPeriod}>
          <Field name='financial_statement' checked label='Extrato financeiro' component={CheckboxFormField} fullWidth={false} />
          <div className={classes.periodLabel}>Período</div>
          <div className={classes.periodContainer}>
            <Field
              id='date'
              label=''
              name='date'
              customPreset={datePreset}
              component={DateRangePickerFormField}
              isOutsideRange={isOutsideRange}
              maxDate={moment()}
            />
          </div>
        </div>
        {errors.date && <FormHelperText error>{errors.date}</FormHelperText>}

        <Field name='export_in_future' label='Lançamentos futuros' component={CheckboxFormField} fullWidth={false} />

        <Field name='export_blocked' label='Lançamentos bloqueados' component={CheckboxFormField} fullWidth={false} />
      </div>

      <Field id='email' name='email' label='E-mail' placeholder={user?.email} component={TextFormField} fullWidth />

      {!!values.email && !errors.email && values?.email !== user?.email && (
        <Alert className={classes.alertEmail} severity='warning'>
          Esse e-mail é diferente do e-mail de cadastro, tem certeza que deseja enviar para esse e-mail?
        </Alert>
      )}
    </>
  );
}

export default Form;
